export const addActionIconCss = {
  path: {
    stroke: "currentColor",
  },
};
